/** @see Design.language and @see DesignLanguage.language. */
export enum LanguageCode {
  arabicAe = 'ar-AE',
  arabicXa = 'ar-XA',
  chineseCn = 'zh-CN',
  chineseMandarinCn = 'cmn-CN',
  chineseSg = 'zh-SG',
  danishDa = 'da-DA',
  dutchNl = 'nl-NL',
  englishAu = 'en-AU',
  englishCa = 'en-CA',
  /**
   * English for The United Kingdom of Great Britian and Northern Ireland.
   *
   * @note We use this for @see Design languages, but use @see englishUk for text to speech voices.
   */
  englishGb = 'en-GB',
  englishSg = 'en-SG',
  /**
   * English for United Kingdom.
   *
   * @note We use this for text to speech voices, but use @see englishGb for @see Design languages.
   */
  englishUk = 'en-UK',
  englishUs = 'en-US',
  finnishFi = 'fi-FI',
  frenchCa = 'fr-CA',
  frenchFr = 'fr-FR',
  germanAt = 'de-AT',
  germanDe = 'de-DE',
  germanLu = 'de-LU',
  greekEl = 'el-EL',
  /** Haitian, Haitian Creole for United States. */
  haitianUs = 'ht-US',
  hebrewIl = 'he-IL',
  hindiIn = 'hi-IN',
  indonesianId = 'id-ID',
  italianIt = 'it-IT',
  japaneseJp = 'ja-JP',
  koreanKo = 'ko-KO',
  polishPl = 'pl-PL',
  portugueseBr = 'pt-BR',
  portuguesePt = 'pt-PT',
  romanianRo = 'ro-RO',
  russianRu = 'ru-RU',
  spanishEs = 'es-ES',
  spanishMx = 'es-MX',
  spanishUs = 'es-US',
  /** @deprecated Use @see spanishUs. */
  spanishUsOld = 'SPANISH_US',
  swedishSe = 'sv-SE',
  thaiTh = 'th-TH',
  turkishTr = 'tr-TR',
  vietnameseVn = 'vi-VN'
}
